import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-center flex flex-wrap w-11/12 m-auto xl:w-1/2" }
const _hoisted_2 = { class: "md:flex-1 text-center m-auto" }
const _hoisted_3 = { class: "text-3xl text-center mb-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" メンバー")
const _hoisted_5 = { class: "m-auto border-collapse border-2 border-gray-500" }
const _hoisted_6 = { class: "flex flex-col md:flex-row border-b border-gray-400" }
const _hoisted_7 = { class: "px-2 pt-2 flex-grow" }
const _hoisted_8 = { class: "info-title py-1 mx-5" }
const _hoisted_9 = {
  class: "m-auto px-2 pb-1 md:py-2",
  align: "justfy"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "md:border-r-2 md:border-gray-300" }, null, -1)
const _hoisted_13 = { class: "text-center md:flex-1" }
const _hoisted_14 = { class: "text-3xl text-center mb-2" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" その他のデータ ")
const _hoisted_16 = { class: "m-auto border-collapse border-b-1 border-gray-500" }
const _hoisted_17 = { class: "border-b border-gray-400 px-2 py-2" }
const _hoisted_18 = { class: "border-b border-gray-400 px-2 py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createVNode(_component_fa, { icon: "users" }),
        _hoisted_4
      ]),
      _createElementVNode("table", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info_data, (info) => {
          return (_openBlock(), _createElementBlock("tbody", {
            key: info.url
          }, [
            _createElementVNode("tr", _hoisted_6, [
              _createElementVNode("td", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(info.talent_name), 1)
              ]),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("a", {
                  class: "m-2",
                  href: info.talent_channel,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, [
                  _createVNode(_component_fa, { icon: { prefix: 'fab', iconName: 'youtube' } })
                ], 8, _hoisted_10),
                _createElementVNode("a", {
                  class: "m-2",
                  href: info.talent_twitter,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, [
                  _createVNode(_component_fa, { icon: { prefix: 'fab', iconName: 'twitter' } })
                ], 8, _hoisted_11)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("h2", _hoisted_14, [
        _createVNode(_component_fa, { icon: "info-circle" }),
        _hoisted_15
      ]),
      _createElementVNode("table", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unit_data, (value, key, index) => {
          return (_openBlock(), _createElementBlock("tbody", { key: index }, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_17, [
                _createElementVNode("p", null, _toDisplayString(key), 1)
              ]),
              _createElementVNode("td", _hoisted_18, [
                _createElementVNode("p", null, _toDisplayString(value), 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}